"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ecsclient_1 = require("@skype/ecsclient");
const Models_1 = require("@skype/ecsclient/dist/Models");
const config_1 = require("config");
const SyncTasks = require("synctasks");
class EcsHelper {
    constructor() {
        this._ecsClient = new ecsclient_1.default();
    }
    loadConfig(skypetoken, expiration, callback, fallback) {
        return this._ecsClient.initialize({
            clientName: 'Launcher',
            clientVersion: '1.0.0.0',
            configsToFetch: (!!skypetoken) ? [Models_1.EcsConfigType.User] : [Models_1.EcsConfigType.Default],
            hosts: [config_1.default.urls.ecs],
            initialAppActiveState: true,
            getEcsParameters: () => SyncTasks.Resolved({}),
            initialSkypeTokenData: {
                skypeToken: skypetoken,
                skypeTokenExpiration: Date.now() + (expiration || 0),
            },
        }).then(() => {
            this._ecsClient.configUpdated.subscribe(() => {
                const response = this._ecsClient.getConfig();
                if (!!response && !!response.config) {
                    callback(response.config.SWG_WebClient);
                }
                else {
                    callback(fallback);
                }
            });
        });
    }
}
exports.ecsHelper = new EcsHelper();
